import React from 'react';

import { LegacyDiagnosticPdpContributor } from './diagnostic-pdp-contributor';
import { ProductDetailFlow } from './product-detail-flow';

export const ProductDetail: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <LegacyDiagnosticPdpContributor />
      <ProductDetailFlow />
    </>
  );
};
